import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setCarritoPromos } from "../Redux/actions/CarritoPromoAction";
import { setCarrito } from "../Redux/actions/CarritoAction";

import * as constant from "../global/const";
import auth from "../Helpers/auth";

export const useCounter = (
  value = 0,
  setMessage,
  setShowMessage,
  setShowModalRedemption
) => {
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  let carritoPromosRedux = useSelector(
    (state) => state.carritoPromo.carritoPromos
  );
  var _carrito = JSON.parse(localStorage.getItem(constant.CARRITO)) || {};
  let _carritoPromos = JSON.parse(localStorage.getItem(constant.CARRITOPROMO)) || {};

  const sucursal = useSelector((state) => state.page.sucursal);
  let user = JSON.parse(auth.getUsuario());
  //let _carrito = useSelector(state => state.carrito.carrito);

  const dispatch = useDispatch();
  const dispatchPromo = useDispatch();
  const AgregarCarrito = (carrito) => dispatch(setCarrito(carrito));
  const AgregarCarritoPromos = (carritoPromos) =>
    dispatchPromo(setCarritoPromos(carritoPromos));

  const [counter, setCounter] = useState(value);
  const [totalAmount, setTotalAmount] = useState(0);
  const [ico, setIco] = useState(0);
  const [iva, setIva] = useState(0);
  const [ibua, setIbua] = useState(0);
  const [icui, setIcui] = useState(0);
  const [icl, setIcl] = useState(0);
  const [adv, setAdv] = useState(0);
  const [descuento, setDescuento] = useState(0);
  const [envaces, setEnvaces] = useState(0);
  const [retornables, setRetornables] = useState(0); //calcular cuantos productos son retornables

  const obtenerRedenciones = () => {
    const keys = Object.keys(carritoPromosRedux);
    let llaves = [];

    if (keys.length > 0) {
      keys.map((key) => {
        const newObject = {
          numProm: carritoPromosRedux[key]["numProm"],
          cantidadReclamada: carritoPromosRedux[key]["cantidadReclamada"],
        };
        llaves.push(newObject);
      });
    }

    return llaves;
  };

  const obtenerProductos = async (codigoSku) => {
    const keys = Object.keys(_carrito);
    let productos = [];
    if (keys.length > 0) {
      keys.map((key) => {
        if (key.replace("-", "") != codigoSku) {
          const newObject = {
            codigoSku: _carrito[key]["codigoSku"],
            cantidad: _carrito[key]["cantidad"],
            presentacionId: _carrito[key]["presentacionId"],
            unidadesxCaja: _carrito[key]["unidadesxCaja"],
            numprom:
              _carrito[key]["promocionRedime"].length > 0
                ? _carrito[key].promocionRedime[0].numProm
                : 0,
          };
          productos.push(newObject);
        }
      });
    }

    return productos;
  };

  const validarRedime = async (codigoSku, numProm, cantidad, unidadesxCaja) => {
    let aux = {};
    const redimido = obtenerRedenciones();
    const carrito = await obtenerProductos(codigoSku);
    await axios
      .post(
        constant.GETVALIDACIONREDIME +
          `?nit=${sucursal.nit}&codigo=${sucursal.codigo}&agencia=${sucursal.agencia}&correo=${user.email}&numprom=${numProm}`,
        {
          codigoSku: codigoSku,
          cantidad: cantidad,
          unidadesxCaja: unidadesxCaja,
          carrito: carrito,
          redimido: redimido,
        }
      )
      .then((response) => {
        if(response?.code == "REDIME_ERROR"){
          console.log("'error' redime -> ", response.data.mensaje ?? "");
        } else{
          aux = response.data;
        }
      })
      .catch((err) => {
        console.log("'error' redime -> ", err);
      });
    return aux;
  };

  //validar campo input
  const handleInputChange = (value, producto, setCurrentValue) => {
    // Regex para 4 dígitos, con opción de .5 si permite media
    let reg = /^(\d{0,4})(\.[5]{1})?$/gm;
    if (producto.permiteMedia != 1) {
      reg = /^(\d{0,4})?$/gm;
    }
    
    if (!isNaN(value) && reg.test(value) && value.length <= 4) {
      // Validar que el valor no exceda 8000
      const valorNumerico = parseFloat(value);
      if (!isNaN(valorNumerico) && valorNumerico > 8000) {
        setCurrentValue('8000');
        return;
      }
      setCurrentValue(value);
      return;
    }
    
    if (value === '') {
      setCurrentValue('');
      return;
    }
  };

  const handleInputBlur = (value, producto, setCurrentValue) => {
    setCurrentValue(undefined);
    let valorNumerico = parseFloat(value);

    // Validar que no exceda 8000
    if (!isNaN(valorNumerico) && valorNumerico > 8000) {
      valorNumerico = 8000;
    }
  
    prueba(producto, valorNumerico);  
  };


  const handleSubmitAdd = (num = 1) => {
    setCounter((value) => value + num);
  };

  //#ModicarFrontCaja
  const handleSubmitAddValidate = (producto, num = 1, validate = true) => {
    if (validate) {
      if (isMediaCajaValidate(producto) && counter < 1) {
        num = 0.5;
      } else if (!Number.isInteger(counter) && counter >= 0.5 ) {
        num = 0.5;
      }
    }
    if( (counter + num) <= 8000){
      setCounter((value) => value + num);
      handleChangeToCard(producto, num);
    }
  };

  const isMediaCajaValidate = (producto) => {
    return producto.permiteMedia === 1 ? true : false;
  };

  const handleSubmitSubtract = (num = 1) => {
    setCounter((value) => (value - num < 0 ? value : value - num));
  };

  const handleSubmitSubtractValidate = (producto, num = 1, validate=true) => {
    if(validate){
      if (!Number.isInteger(counter)) {
        num = 0.5;
      }
      else if (isMediaCajaValidate(producto) && counter == 1) {
        num = 0.5;
      }
    }
    setCounter((value) => (value - num < 0 ? value : value - num));
    subtractFromCart(producto, num);
  };

  const searchRedemptionByPresentationShoppCart = (
    idActual,
    numPresentacion,
    numProm
  ) => {
    const aux = Object.keys(carritoRedux);
    let auxkey = "";

    aux.map((key) => {
      const promocion = carritoRedux[key]["promocion"].filter(
        (promo) => promo.tipoDescuento == 1
      );

      //En caso de que no se alcanzara a eliminar, el producto
      if (key != "-" + idActual) {
        //Validar que no tenga una promoción activa
        if (promocion.length == 0) {
          const promocionRedime = carritoRedux[key]["promocionRedime"].filter(
            (promoR) => promoR.tipoDescuento == 5
          );

          //Que si tenga promoción redime
          if (promocionRedime.length > 0) {
            if (
              carritoRedux[key]["presentacionId"] == numPresentacion &&
              promocionRedime[0].numProm == numProm
            ) {
              auxkey = key;
            }
          }
        }
      }
    });

    return auxkey;
  };

  const findPromoIdByNumprom = (numProm) => {
    const promoKeys = Object.keys(carritoPromosRedux);
    const promoKeysByNumProm = promoKeys.filter(
      (promoKey) => carritoPromosRedux[promoKey].numProm == numProm
    );

    return promoKeysByNumProm;
  };

  const deletePromoByTypeIntegration = (productoSkuCode, numPromo) => {
    if (carritoPromosRedux["-" + productoSkuCode]) {
      delete carritoPromosRedux["-" + productoSkuCode];
      AgregarCarritoPromos({ ...carritoPromosRedux });
      return;
    }

    const skuCodePromoByNumProm = findPromoIdByNumprom(numPromo)[0];
    if (skuCodePromoByNumProm) {
      delete carritoPromosRedux[skuCodePromoByNumProm];
    }

    AgregarCarritoPromos({ ...carritoPromosRedux });
    return;
  };

  const deletePromoRedemption = async (producto, promocionRedime) => {
    //Borrar la referencia anterior
    let auxkey = searchRedemptionByPresentationShoppCart(
      producto.codigoSku,
      producto.presentacionId,
      promocionRedime[0].numProm
    );

    if (auxkey.length > 0) {
      let backup = {
        ...carritoPromosRedux["-" + producto.codigoSku],
      };
      backup.codigoSku = auxkey.replace("-", "");
      backup.nombre = carritoRedux[auxkey].nombre;

      delete carritoPromosRedux["-" + producto.codigoSku];

      await validarRedime(
        producto.codigoSku,
        promocionRedime[0].numProm,
        0,
        producto.unidadesxCaja
      ).then((respuesta) => {
        if (Object.keys(respuesta).length > 0) {
          if (backup.cantidadReclamada > respuesta.cantidadObsequiada) {
            backup["seleccionados"] = [];
          }
          backup["cantidadObsequiada"] = respuesta.cantidadObsequiada;
          backup["cantidadReclamada"] = 0;
          backup["unidadesxCaja"] = respuesta.unidadesxCaja

          //Se guarda con la nueva referencia
          carritoPromosRedux[auxkey] = backup;

          if (setMessage && setShowMessage && setShowModalRedemption) {
            setShowModalRedemption(false);
            setShowMessage(false);
            AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
              setMessage(
                promocionRedime[0].textoDescuentoDetalle +
                  "-" +
                  auxkey.replace("-", "")
              );
              setShowMessage(true);
            });
          }
        } else {
          if (setMessage && setShowMessage && setShowModalRedemption) {
            setShowModalRedemption(false);
            setShowMessage(false);
          }
          AgregarCarritoPromos({ ...carritoPromosRedux });
        }
      });
    } else {
      delete carritoPromosRedux["-" + producto.codigoSku];
      AgregarCarritoPromos({ ...carritoPromosRedux });
    }
  };
  const searchRedemptionByPresentation = (numPresentacion, numProm) => {
    const aux = Object.keys(carritoPromosRedux);
    let auxkey = "";
    aux.map((key) => {
      if (
        carritoPromosRedux[key]["numPresentacion"] == numPresentacion &&
        carritoPromosRedux[key]["numProm"] == numProm
      ) {
        auxkey = key;
      }
    });

    return auxkey;
  };

  const handleDeleteToCart = (producto) => {
    const { promocionRedime } = producto;

    if (_carrito["-" + producto.codigoSku]) {
      delete _carrito["-" + producto.codigoSku];
      AgregarCarrito(_carrito);

      const typeIntegration =
        (producto &&
          producto.promocionRedime &&
          producto.promocionRedime[0] &&
          producto.promocionRedime[0].tipoIntegracion) ||
        0;

      if (typeIntegration) {
        deletePromoByTypeIntegration(producto, promocionRedime[0].numProm);
      }
      if (_carritoPromos["-" + producto.codigoSku]) {
        const promocionRedime = producto.promocionRedime.filter(
          (promoR) => promoR.tipoDescuento == 5
        );
        deletePromoRedemption(producto, promocionRedime);
      }
    }

    //Validación, determinar si tenia una promoción, eliminarla del mismo
  };

  const subtractFromCart = async (producto, value = 1) => {
    const promocion = producto.promocion.filter(
      (promo) => promo.tipoDescuento == 1
    );
    const promocionRedime = producto.promocionRedime.filter(
      (promoR) => promoR.tipoDescuento == 5
    );
    const typeIntegration =
      (producto &&
        producto.promocionRedime &&
        producto.promocionRedime[0] &&
        producto.promocionRedime[0].tipoIntegracion) ||
      0;
    let cantidad = counter - value;

    if (cantidad >= 0) {
      if (_carrito["-" + producto.codigoSku]) {
        if (cantidad == 0) {
          delete _carrito["-" + producto.codigoSku];

          //Validación redenciones de tipo presentación
          if (typeIntegration) {
            deletePromoByTypeIntegration(
              producto,
              producto.promocionRedime[0].numProm
            );
          }
          if (carritoPromosRedux["-" + producto.codigoSku]) {
            deletePromoRedemption(producto, promocionRedime);

            let auxkey = searchRedemptionByPresentation(
              producto.presentacionId,
              promocionRedime[0].numProm
            );

            if (auxkey.length > 0) {
              //Se debe tener en cuenta que ya no esta el producto
              await validarRedime(
                producto.codigoSku,
                promocionRedime[0].numProm,
                cantidad,
                producto.unidadesxCaja
              ).then((respuesta) => {
                if (Object.keys(respuesta).length > 0) {
                  if (
                    carritoPromosRedux[auxkey]["cantidadReclamada"] >
                    respuesta.cantidadObsequiada
                  ) {
                    carritoPromosRedux[auxkey]["seleccionados"] = [];
                    carritoPromosRedux[auxkey]["cantidadReclamada"] = 0;
                  }
                  carritoPromosRedux[auxkey]["cantidadObsequiada"] =
                    respuesta.cantidadObsequiada;
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setShowModalRedemption(false);
                    setShowMessage(false);
                    AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                      setMessage(
                        promocionRedime[0].textoDescuentoDetalle +
                          "-" +
                          auxkey.replace("-", "")
                      );
                      setShowMessage(true);
                    });
                  }
                }
              });
            }
          } else {
          }
        } else {
          _carrito["-" + producto.codigoSku]["cantidad"] = cantidad;

          if (promocion.length == 0) {
            if (promocionRedime.length > 0) {
              await validarRedime(
                producto.codigoSku,
                promocionRedime[0].numProm,
                cantidad,
                producto.unidadesxCaja
              ).then((respuesta) => {
                if (Object.keys(respuesta).length > 0) {
                  if (carritoPromosRedux["-" + producto.codigoSku]) {
                    if (respuesta.cantidadObsequiada) {
                      carritoPromosRedux["-" + producto.codigoSku][
                        "cantidadObsequiada"
                      ] = respuesta.cantidadObsequiada;
                    }
                    if (respuesta.tipo == 1) {
                      if (
                        carritoPromosRedux["-" + producto.codigoSku][
                          "seleccionados"
                        ].length > 0
                      ) {
                        carritoPromosRedux["-" + producto.codigoSku][
                          "seleccionados"
                        ][0].cantidad = respuesta.cantidadObsequiada;
                        carritoPromosRedux["-" + producto.codigoSku][
                          "seleccionados"
                        ][0].unidadesxCaja = producto.unidadesxCaja;
                        carritoPromosRedux["-" + producto.codigoSku][
                          "cantidadReclamada"
                        ] = respuesta.cantidadObsequiada;
                        carritoPromosRedux["-" + producto.codigoSku][
                          "unidadesxCaja"
                        ] = respuesta.unidadesxCaja;
                      }
                    } else {
                      if (
                        carritoPromosRedux["-" + producto.codigoSku][
                          "cantidadReclamada"
                        ] > respuesta.cantidadObsequiada
                      ) {
                        carritoPromosRedux["-" + producto.codigoSku][
                          "seleccionados"
                        ] = [];
                      }
                      carritoPromosRedux["-" + producto.codigoSku][
                        "cantidadObsequiada"
                      ] = respuesta.cantidadObsequiada;
                      carritoPromosRedux["-" + producto.codigoSku][
                        "unidadesxCaja"
                      ] = respuesta.unidadesxCaja;
                    }
                  } else {
                    let auxkey = searchRedemptionByPresentation(
                      producto.presentacionId,
                      promocionRedime[0].numProm
                    );

                    if (auxkey.length > 0) {
                      const auxFlag =
                        carritoPromosRedux[auxkey]["cantidadObsequiada"] !=
                        respuesta.cantidadObsequiada;

                      if (
                        carritoPromosRedux[auxkey]["cantidadReclamada"] >
                        respuesta.cantidadObsequiada
                      ) {
                        carritoPromosRedux[auxkey]["seleccionados"] = [];
                        carritoPromosRedux[auxkey]["cantidadReclamada"] = 0;
                      }
                      carritoPromosRedux[auxkey]["cantidadObsequiada"] =
                        respuesta.cantidadObsequiada;
                      if (
                        setMessage &&
                        setShowMessage &&
                        setShowModalRedemption
                      ) {
                        setShowModalRedemption(false);
                        setShowMessage(false);
                        AgregarCarritoPromos({ ...carritoPromosRedux }).then(
                          () => {
                            if (auxFlag) {
                              setMessage(
                                promocionRedime[0].textoDescuentoDetalle +
                                  "-" +
                                  auxkey.replace("-", "")
                              );
                              setShowMessage(true);
                            }
                          }
                        );
                      }
                    }
                  }
                } else {
                  if (typeIntegration) {
                    deletePromoByTypeIntegration(
                      producto,
                      producto.promocionRedime[0].numProm
                    );
                  }
                  delete carritoPromosRedux["-" + producto.codigoSku];
                  //una validación, con el tema, de las redenciones
                }
                AgregarCarritoPromos({ ...carritoPromosRedux });
              });
            }
          }
        }
        AgregarCarrito(_carrito);
        getTotalAmount();
      }
    }
    //Validación, # de (tipo - presentación) B tengo derecho Si compro # cantidades de A
  };

  const prueba = async (producto, value) => {

    if(counter !== value){
        let num = 0;
        if(counter < value){
            num = value - counter;
            handleSubmitAddValidate(producto,num,false)
            //handleSubmitAdd(num);
            //handleChangeToCard(producto,num);
        }else if ( counter > value) {
            num = counter - value;
            //handleSubmitSubtract(num);
            //subtractFromCart(producto, num);
            handleSubmitSubtractValidate(producto,num,false)
        }
    }
  };

  const handleChangeToCard = async (producto, value = 1) => {
    let cantidad = counter + value;
    const promocion = producto.promocion.filter(
      (promo) => promo.tipoDescuento == 1
    );
    const promocionRedime = producto.promocionRedime.filter(
      (promoR) => promoR.tipoDescuento == 5
    );

    if (_carrito["-" + producto.codigoSku]) {
      _carrito["-" + producto.codigoSku]["cantidad"] = cantidad;
      AgregarCarrito(_carrito);
      getTotalAmount();

      if (promocion.length == 0) {
        if (promocionRedime.length > 0) {
          await validarRedime(
            producto.codigoSku,
            promocionRedime[0].numProm,
            cantidad,
            producto.unidadesxCaja
          ).then((respuesta) => {
            if (carritoPromosRedux["-" + producto.codigoSku]) {
              if (Object.keys(respuesta).length > 0) {
                const auxFlag =
                  carritoPromosRedux["-" + producto.codigoSku][
                    "cantidadObsequiada"
                  ] != respuesta.cantidadObsequiada;

                if (respuesta.cantidadObsequiada) {
                  //Ojo aquí
                  carritoPromosRedux["-" + producto.codigoSku][
                    "cantidadObsequiada"
                  ] = respuesta.cantidadObsequiada;
                }

                if (respuesta.tipo == 1) {
                  if (
                    carritoPromosRedux["-" + producto.codigoSku][
                      "seleccionados"
                    ].length > 0
                  ) {
                    //Ojo aquí
                    carritoPromosRedux["-" + producto.codigoSku][
                      "seleccionados"
                    ][0].cantidad = respuesta.cantidadObsequiada;
                    carritoPromosRedux["-" + producto.codigoSku][
                      "seleccionados"
                    ][0].unidadesxCaja = respuesta.unidadesxCaja;
                  }
                }
                AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    if (auxFlag) {
                      setMessage(
                        promocionRedime[0].textoDescuentoDetalle +
                          "-" +
                          producto.codigoSku
                      );
                      setShowMessage(true);
                      setShowModalRedemption(true);
                    }
                  }
                });
              } else {
                delete carritoPromosRedux["-" + producto.codigoSku];
                //Validación, # de (tipo - presentación) B tengo derecho Si compro # cantidades de A
                //Se llama el metodo que valida
                AgregarCarritoPromos({ ...carritoPromosRedux });
              }
            } else if (Object.keys(respuesta).length > 0) {
              let auxkey = searchRedemptionByPresentation(
                producto.presentacionId,
                promocionRedime[0].numProm
              );

              if (auxkey.length > 0) {
                const auxFlag =
                  carritoPromosRedux[auxkey]["cantidadObsequiada"] !=
                  respuesta.cantidadObsequiada;

                carritoPromosRedux[auxkey]["cantidadObsequiada"] =
                  respuesta.cantidadObsequiada;
                AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                  if (auxFlag) {
                    if (
                      setMessage &&
                      setShowMessage &&
                      setShowModalRedemption
                    ) {
                      setMessage(
                        promocionRedime[0].textoDescuentoDetalle +
                          "-" +
                          auxkey.replace("-", "")
                      );
                      setShowMessage(true);
                      setShowModalRedemption(true);
                    }
                  }
                });
              } else {
                const seleccionados =
                  respuesta.tipo == 1
                    ? [
                        {
                          nombre: respuesta.redime[0].nombre,
                          cantidad: respuesta.cantidadObsequiada,
                          codigoSkuPromocion: respuesta.redime[0].codigoSku,
                          precio: respuesta.redime[0].precio,
                          unidadesxCaja: respuesta.redime[0].unidadesxCaja,
                        },
                      ]
                    : [];
                carritoPromosRedux["-" + producto.codigoSku] = {
                  codigoSku: producto.codigoSku,
                  nombre: producto.nombre,
                  textoDescuentoDetalle:
                    promocionRedime[0].textoDescuentoDetalle,
                  ...respuesta,
                  seleccionados: seleccionados,
                  cantidadReclamada:
                    respuesta.tipo == 1 ? respuesta.cantidadObsequiada : 0,
                  numProm: promocionRedime[0].numProm,
                  numPresentacion: producto.presentacionId,
                };
                AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setMessage(
                      promocionRedime[0].textoDescuentoDetalle +
                        "-" +
                        producto.codigoSku
                    );
                    setShowMessage(true);
                    setShowModalRedemption(true);
                  }
                });
              }
            }
          });
        }
      }
    } else {
      _carrito["-" + producto.codigoSku] = {
        codigoSku: producto.codigoSku,
        nombre: producto.nombre,
        precio: promocion.length
          ? parseFloat(promocion[0].precio)
          : parseFloat(producto.precio),
        precioBase: promocion.length
          ? parseFloat(promocion[0].precioBase)
          : parseFloat(producto.precioBase),
        retornable: producto.retornable,
        oferta: producto.oferta,
        iva:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].ivaPesos)
            : parseFloat(producto.ivaPesos),
        ipo:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].ipo)
            : parseFloat(producto.ipo),
        icui:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].icuipesos)
            : parseFloat(producto.icuipesos),
        ibua:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].ibua)
            : parseFloat(producto.ibua),
        icl:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].icl)
            : parseFloat(producto.icl),
        adv:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].adv)
            : parseFloat(producto.adv),
        cantidad: cantidad,
        unidadesxCaja: producto.unidadesxCaja,
        categoria: producto.categoriaId,
        vinetas: producto.vinetas,
        promocion: producto.promocion,
        promocionRedime: producto.promocionRedime,
        presentacionId: producto.presentacionId,
        permiteMedia: producto.permiteMedia,
      };

      if (promocion.length == 0) {
        if (promocionRedime.length > 0) {
          await validarRedime(
            producto.codigoSku,
            promocionRedime[0].numProm,
            cantidad,
            producto.unidadesxCaja
          ).then((respuesta) => {
            let auxkey = searchRedemptionByPresentation(
              producto.presentacionId,
              promocionRedime[0].numProm
            );

            if (auxkey.length > 0) {
              const auxFlag =
                carritoPromosRedux[auxkey]["cantidadObsequiada"] !=
                respuesta.cantidadObsequiada;

              carritoPromosRedux[auxkey]["cantidadObsequiada"] =
                respuesta.cantidadObsequiada;
              AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                if (auxFlag) {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setMessage(
                      promocionRedime[0].textoDescuentoDetalle +
                        "-" +
                        auxkey.replace("-", "")
                    );
                    setShowMessage(true);
                    setShowModalRedemption(true);
                  }
                }
              });
            } else {
              const seleccionados =
                respuesta.tipo == 1
                  ? [
                      {
                        nombre: respuesta.redime[0].nombre,
                        cantidad: respuesta.cantidadObsequiada,
                        codigoSkuPromocion: respuesta.redime[0].codigoSku,
                        unidadesxCaja: respuesta.redime[0].unidadesxCaja,
                      },
                    ]
                  : [];

              if (Object.keys(respuesta).length > 0) {
                carritoPromosRedux["-" + producto.codigoSku] = {
                  codigoSku: producto.codigoSku,
                  nombre: producto.nombre,
                  textoDescuentoDetalle:
                    promocionRedime[0].textoDescuentoDetalle,
                  ...respuesta,
                  seleccionados: seleccionados,
                  cantidadReclamada:
                    respuesta.tipo == 1 ? respuesta.cantidadObsequiada : 0,
                  numProm: promocionRedime[0].numProm,
                  numPresentacion: producto.presentacionId,
                };
                AgregarCarritoPromos({ ...carritoPromosRedux }).then(() => {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setMessage(
                      promocionRedime[0].textoDescuentoDetalle +
                        "-" +
                        producto.codigoSku
                    );
                    setShowMessage(true);
                    setShowModalRedemption(true);
                  }
                });
              }
            }
          });
        }
      }
    }
    AgregarCarrito(_carrito);
    getTotalAmount();
  };

  const handleAddToCart = async (producto) => {
    //Se captura si un producto tiene

    if (counter > 0) {
      const promocion = producto.promocion.filter(
        (promo) => promo.tipoDescuento == 1
      );
      const promocionRedime = producto.promocionRedime.filter(
        (promoR) => promoR.tipoDescuento == 5
      );

      if (_carrito["-" + producto.codigoSku]) {
        _carrito["-" + producto.codigoSku]["cantidad"] = counter;

        if (promocion.length == 0) {
          if (promocionRedime.length > 0) {
            await validarRedime(
              producto.codigoSku,
              promocionRedime[0].numProm,
              counter,
              producto.unidadesxCaja
            ).then((respuesta) => {
              if (_carritoPromos["-" + producto.codigoSku]) {
                //Se llama el metodo que valida
                if (Object.keys(respuesta).length > 0) {
                  if (respuesta.cantidadObsequiada) {
                    _carritoPromos["-" + producto.codigoSku][
                      "cantidadObsequiada"
                    ] = respuesta.cantidadObsequiada;
                  }

                  if (respuesta.tipo == 1) {
                    if (
                      _carritoPromos["-" + producto.codigoSku]["seleccionados"]
                        .length > 0
                    ) {
                      _carritoPromos["-" + producto.codigoSku][
                        "seleccionados"
                      ][0].cantidad = respuesta.cantidadObsequiada;
                      _carritoPromos["-" + producto.codigoSku][
                        "seleccionados"
                      ][0].unidadesxCaja = respuesta.unidadesxCaja;
                    }
                  }
                  AgregarCarritoPromos(_carritoPromos).then(() => {
                    if (
                      setMessage &&
                      setShowMessage &&
                      setShowModalRedemption
                    ) {
                      setMessage(
                        promocionRedime[0].textoDescuentoDetalle +
                          "-" +
                          producto.codigoSku
                      );
                      setShowMessage(true);
                      setShowModalRedemption(true);
                    }
                  });
                } else {
                  delete _carritoPromos["-" + producto.codigoSku];
                  AgregarCarritoPromos(_carritoPromos);
                }
              } else if (Object.keys(respuesta).length > 0) {
                const seleccionados =
                  respuesta.tipo == 1
                    ? [
                        {
                          nombre: respuesta.redime[0].nombre,
                          cantidad: respuesta.cantidadObsequiada,
                          codigoSkuPromocion: respuesta.redime[0].codigoSku,
                          unidadesxCaja: respuesta.redime[0].unidadesxCaja,
                        },
                      ]
                    : [];

                _carritoPromos["-" + producto.codigoSku] = {
                  codigoSku: producto.codigoSku,
                  nombre: producto.nombre,
                  textoDescuentoDetalle:
                    promocionRedime[0].textoDescuentoDetalle,
                  ...respuesta,
                  seleccionados: seleccionados,
                  cantidadReclamada:
                    respuesta.tipo == 1 ? respuesta.cantidadObsequiada : 0,
                  numProm: promocionRedime[0].numProm,
                  numPresentacion: producto.presentacionId,
                };
                AgregarCarritoPromos(_carritoPromos).then(() => {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setMessage(
                      promocionRedime[0].textoDescuentoDetalle +
                        "-" +
                        producto.codigoSku
                    );
                    setShowMessage(true);
                    setShowModalRedemption(true);
                  }
                });
              }
            });
          }
        }
      } else {
        _carrito["-" + producto.codigoSku] = {
          codigoSku: producto.codigoSku,
          nombre: producto.nombre,
          precio: promocion.length
            ? parseFloat(promocion[0].precio)
            : parseFloat(producto.precio),
          precioBase: promocion.length
            ? parseFloat(promocion[0].precioBase)
            : parseFloat(producto.precioBase),
          retornable: producto.retornable,
          oferta: producto.oferta,
          iva:
          producto.promocion.length > 0
            ? parseFloat(producto.promocion[0].ivaPesos)
            : parseFloat(producto.ivaPesos),
          ipo:
            producto.promocion.length > 0
              ? parseFloat(producto.promocion[0].ipo)
              : parseFloat(producto.ipo),
          icui:
            producto.promocion.length > 0
              ? parseFloat(producto.promocion[0].icuipesos)
              : parseFloat(producto.icuipesos),
          ibua:
            producto.promocion.length > 0
              ? parseFloat(producto.promocion[0].ibua)
              : parseFloat(producto.ibua),
          icl:
            producto.promocion.length > 0
              ? parseFloat(producto.promocion[0].icl)
              : parseFloat(producto.icl),
          adv:
            producto.promocion.length > 0
              ? parseFloat(producto.promocion[0].adv)
              : parseFloat(producto.adv),
          cantidad: counter,
          unidadesxCaja: producto.unidadesxCaja,
          categoria: producto.categoriaId,
          vinetas: producto.vinetas,
          promocion: producto.promocion,
          promocionRedime: producto.promocionRedime,
          presentacionId: producto.presentacionId,
          permiteMedia: producto.permiteMedia,
        };

        if (promocion.length == 0) {
          if (promocionRedime.length > 0) {
            await validarRedime(
              producto.codigoSku,
              promocionRedime[0].numProm,
              counter,
              producto.unidadesxCaja
            ).then((respuesta) => {
              const seleccionados =
                respuesta.tipo == 1
                  ? [
                      {
                        nombre: respuesta.redime[0].nombre,
                        cantidad: respuesta.cantidadObsequiada,
                        codigoSkuPromocion: respuesta.redime[0].codigoSku,
                        unidadesxCaja: respuesta.redime[0].unidadesxCaja,
                      },
                    ]
                  : [];

              if (Object.keys(respuesta).length > 0) {
                _carritoPromos["-" + producto.codigoSku] = {
                  codigoSku: producto.codigoSku,
                  nombre: producto.nombre,
                  textoDescuentoDetalle:
                    promocionRedime[0].textoDescuentoDetalle,
                  ...respuesta,
                  seleccionados: seleccionados,
                  cantidadReclamada:
                    respuesta.tipo == 1 ? respuesta.cantidadObsequiada : 0,
                  numProm: promocionRedime[0].numProm,
                  numPresentacion: producto.presentacionId,
                };
                AgregarCarritoPromos(_carritoPromos).then(() => {
                  if (setMessage && setShowMessage && setShowModalRedemption) {
                    setMessage(
                      promocionRedime[0].textoDescuentoDetalle +
                        "-" +
                        producto.codigoSku
                    );
                    setShowMessage(true);
                    setShowModalRedemption(true);
                  }
                });
              }
              // AgregarCarritoPromos(_carritoPromos);
            });
          }
        }
      }
      AgregarCarrito(_carrito);
      getTotalAmount();
    } else {
      if (_carrito["-" + producto.codigoSku]) {
        if (counter == 0) {
          delete _carrito["-" + producto.codigoSku];
          if (_carritoPromos["-" + producto.codigoSku]) {
            delete _carritoPromos["-" + producto.codigoSku];
            AgregarCarritoPromos(_carritoPromos);
          }
        }
      }
      AgregarCarrito(_carrito);
    }
  };

  const getTotalAmount = () => {
    let _total = 0;
    let _ico = 0;
    let _iva = 0;
    let _envaces = 0;
    let _retornables = 0;
    let _ibua = 0;
    let _icui = 0;
    let _icl = 0;
    let _adv = 0;

    //mp esta calculando envaces, porque no estan en los items
    Object.keys(_carrito).map((item) => {
      _total = _total + _carrito[item].cantidad * _carrito[item].precio;
      _iva = _iva + _carrito[item].cantidad * _carrito[item].iva;
      _ico = _ico + _carrito[item].cantidad * _carrito[item].ipo;
      _ibua = _ibua + _carrito[item].cantidad * (_carrito[item].ibua ? _carrito[item].ibua : 0);
      _icui = _icui + _carrito[item].cantidad * (_carrito[item].icui ? _carrito[item].icui : 0);
      _icl = _icl + _carrito[item].cantidad * (_carrito[item].icl ? _carrito[item].icl : 0);
      _adv = _adv + _carrito[item].cantidad * (_carrito[item].adv ? _carrito[item].adv : 0);
      _retornables =
        _retornables +
        _carrito[item].cantidad * (_carrito[item].retornable != "" ? 1 : 0);
    });
    setIco(_ico);
    setIva(_iva);
    setIcui(_icui);
    setIbua(_ibua);
    setIcl(_icl);
    setAdv(_adv);
    setTotalAmount(_total);
    setRetornables(_retornables);
  };

  useEffect(() => {
    getTotalAmount();
  }, [_carrito]);

  return {
    counter,
    totalAmount,
    iva,
    ico,
    ibua,
    icui,
    icl,
    adv,
    descuento,
    envaces,
    handleSubmitAdd,
    handleSubmitSubtract,
    handleAddToCart,
    handleDeleteToCart,
    subtractFromCart,
    handleChangeToCard,
    getTotalAmount,
    retornables,
    setCounter,
    prueba,
    handleSubmitAddValidate,
    handleSubmitSubtractValidate,
    handleInputChange,
    handleInputBlur,
    isMediaCajaValidate,
  };
};
